import translations from '~/i18n/locales/de.json';
window.translations = translations;
